export default __webpack_public_path__ + "button-toggle-open.25a40c3b810f89990f11.png";